import {apiClient} from '@/services/base/BaseService';


export async function getListOrganizations() {
    const res = await apiClient.get(`organizations`);
    return res.data.data;
}

